module.exports = __webpack_public_path__ + "img/syb.e2915422.png";